module.exports = __webpack_public_path__ + "img/pr-9.f895526d.png";